export function serializeQuery(params, prefix) {
  if (!params) return "";
  const query = Object.keys(params).flatMap(key => {
    const value = params[key];
    if (value === null || value === undefined) return [];

    let nextKey = key;
    if (Array.isArray(params)) nextKey = `${prefix}[]`;
    else if (params.constructor === Object) nextKey = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === "object") {
      const nested = serializeQuery(value, nextKey);
      return nested ? nested : [];
    }
    return `${nextKey}=${encodeURIComponent(value)}`;
  });

  return query.join("&");
}
